import styled, { StyledComponent } from "@emotion/styled";

export function isClient(): boolean {
  return typeof window !== 'undefined';
}

const userAgentRegex = /iPhone|iPod|BlackBerry|Android/;

export function isMobile(): boolean {
  return userAgentRegex.test(navigator.userAgent);
}

export function getPageNameFromRouteName(routeName: string): string {
  return routeName !== '' ? routeName : 'home';
}

export function mobileOnly<T extends object>(
  component: React.ComponentType<T>
): StyledComponent<T, object, object> {
  return styled(component)`
    @media (min-width: 768px) {
      display: none;
    }
  `;
}

export function desktopOnly<T extends object>(
  component: React.ComponentType<T>,
  display = 'block'
): StyledComponent<T, object, object> {
  return styled(component)`
    display: none;

    @media (min-width: 768px) {
      display: ${display};
    }
  `;
}
